export default function ContactSection() {
  return (
    <section id="contact" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="bg-background-50 rounded-2xl border border-background-200/60 p-6 md:p-10 flex flex-col md:flex-row items-center gap-6 md:gap-10">
          <div className="flex-shrink-0 w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-2xl bg-accent-100">
            <i className="ri-mail-send-line text-3xl md:text-4xl text-accent-600"></i>
          </div>
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-2">
              联系我们
            </h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
              有想看的剧？发现内容问题？或者想与我们合作？随时通过以下方式联系悟空影视团队。我们会认真对待每一条反馈，持续优化观影体验。
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <span className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-lg cursor-pointer whitespace-nowrap hover:bg-primary-600 transition-colors">
              <i className="ri-chat-smile-2-line"></i>
              意见反馈
            </span>
            <span className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-700 font-medium text-sm rounded-lg border border-background-300 cursor-pointer whitespace-nowrap hover:bg-background-200/70 transition-colors">
              <i className="ri-mail-line"></i>
              商务合作
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}